import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, BookOpen, Megaphone, Radio, Users, FileCheck, DatabaseBackup, Settings as SettingsIcon } from "lucide-react";

const TABS = [
  { to: "/app/admin", icon: LayoutDashboard, label: "Overview", end: true },
  { to: "/app/admin/courses", icon: BookOpen, label: "Courses" },
  { to: "/app/admin/announcements", icon: Megaphone, label: "Announcements" },
  { to: "/app/admin/live", icon: Radio, label: "Live Classes" },
  { to: "/app/admin/students", icon: Users, label: "Students" },
  { to: "/app/admin/assignments", icon: FileCheck, label: "Assignments" },
  { to: "/app/admin/backup", icon: DatabaseBackup, label: "Backup" },
  { to: "/app/admin/settings", icon: SettingsIcon, label: "Settings" },
];

export default function AdminLayout() {
  return (
    <div className="space-y-6" data-testid="admin-layout">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold">Admin</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-2">Control Center</h1>
          <p className="text-muted-foreground mt-2">Manage everything without touching code.</p>
        </div>
      </div>

      <div className="glass rounded-2xl p-1.5 inline-flex flex-wrap gap-1 border border-border/50">
        {TABS.map(({ to, icon: Icon, label, end }) => (
          <NavLink key={to} to={to} end={end}
            data-testid={`admin-tab-${label.toLowerCase().replace(/ /g, "-")}`}
            className={({ isActive }) =>
              `inline-flex items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-medium transition-all ${
                isActive ? "royal-gradient text-white shadow-[0_8px_20px_-8px_rgba(30,58,138,0.5)]"
                         : "text-muted-foreground hover:text-foreground hover:bg-secondary/50"
              }`
            }>
            <Icon className="h-4 w-4" /> {label}
          </NavLink>
        ))}
      </div>

      <div><Outlet /></div>
    </div>
  );
}
